import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../../updateAction';
import Disclaimer from '../../components/Disclaimer';

import BackButton from '../../components/BackButton';
import Button from '../../components/Button';

import StackForm from '../../components/StackForm';
import Title from '../../components/Title';
import RadioGroup from '../../components/RadioGroup';
import { getPrestamosConsumo } from '../../config';

import { useGlobalData } from '../../../store';

const Data = props => {
  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { setGlobalData } = useGlobalData();
  const { action, state } = useStateMachine(updateAction);

  const [loading, setLoading] = useState(false);
  const [fail, setFail] = useState(false);

  const onSubmit = data => {
    setLoading(true);

    // NOTE: Se asume que es cliente y que tiene ambas tarjetas y ambas cuentas
    const defaultData = {
      es_cliente: true,
      tarjeta: ['tarjeta-visa', 'tarjeta-master'],
      tipo_cuenta: ['tipo_cuenta-cc', 'tipo_cuenta-ca'],
    };

    getPrestamosConsumo({
      monto: state?.data?.monto,
      cuentas: 'AMBAS',
      tarjetas: 'AMBAS',
      moneda: data.moneda,
      tipoPaquete: data.tipoPaquete,
    })
      .then(response => {
        // NOTE: la response de la API se guarda en el state del form
        action({
          ...data,
          es_cliente: defaultData.es_cliente,
          tarjeta: defaultData.es_cliente.tarjeta,
          tipo_cuenta: defaultData.tipo_cuenta,
          response,
        });

        props.history.push('/3');
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setFail(true);
      });
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Tipo de cliente</Title>

        {fail && (
          <Disclaimer
            message="Ocurrió un error."
            subline="Vuelve a intentarlo o comunicate al 1784."
          />
        )}

        <RadioGroup
          type="card"
          name="tipoPaquete"
          options={[
            {
              label: 'Soy cliente',
              value: 'N',
              id: 'cliente',
            },
            {
              label: 'Soy Paquete Full',
              value: 'F',
              id: 'paquete-full',
            },
            {
              label: 'Soy Personal Bank',
              value: 'P',
              id: 'personal-bank',
            },
          ]}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.tipoPaquete}
          defaultChecked={state?.data?.tipoPaquete}
          onChange={e => setGlobalData({ tipoPaquete: e.target.value })}
        />
      </div>

      <div className="form-actions">
        <Button block type="submit" id="pram_siguiente_2" disabled={loading}>
          {loading ? 'cotizando…' : 'siguiente'}
        </Button>

        <BackButton
          onClick={() => document.referrer && (window.location.href = document.referrer)}
        />
      </div>
    </StackForm>
  );
};

export default withRouter(Data);
